import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import EditableTable from '../../../primer/Editable-Table';
import {deleteObjectFromArrayOfObjects} from '../../../../_helpers/helperFunctions';
import {
    getDOYOptions,
    getInstallationsTypes,
    getVatCategoryAbroadOptions,
    getVatCategoryOptions
} from '../../../../_helpers/commonFunctions';
import {
    resetNewInstallations,
    setEditSupplier,
    setNewSupplier,
    setNewInstallations
} from '../../../../_reducers/DataPanel/Suppliers/supplierSlice';
import {setSaveEditSupplier, setSaveNewSupplier} from '../../../../_reducers/activitySlice';
import getMyData from "../../../../_helpers/sharedmydata";
import {toast} from "react-toastify";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewSupplierInstallations = () => {
    const {t, locale} = useTranslation();
    const dispatch = useDispatch();
    const saveNewSupplier = useSelector((state) => state.ACTIVITY.saveNewSupplier);
    const newSupplier = useSelector((state) => state.SUPPLIERS_DATA.newSupplier);
    const newInstallation = useSelector((state) => state.SUPPLIERS_DATA.newInstallation);
    const vatCategoryList = ["Supplier within E.U.", "Supplier outside E.U."].includes(newSupplier.categoryName) ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
    const doyList = ["Supplier within E.U.", "Supplier outside E.U."].includes(newSupplier.categoryName) ? [] : getDOYOptions();
    const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});

    const supplierInstallationsColumns = [
        {
            name: t("General.no"),
            field: "no",
            editable: true,
            inputType: {
                type: 'number',
            }
        },
        {
            name: t("General.type"),
            field: "type",
            editable: true,
            width: "15%",
            inputType: {
                options: getInstallationsTypes(),
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t("General.address"),
            field: "address",
            width: "15%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.doy"),
            field: "DOY",
            editable: true,
            width: "15%",
            inputType: {
                options: doyList,
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t("General.city"),
            field: "city",
            width: "20%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.postalCode"),
            field: "postalCode",
            width: "10%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.vatCategory"),
            field: "vatCategory",
            editable: true,
            width: "15%",
            inputType: {
                options: vatCategoryList,
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t("General.0vatReason"),
            field: "vatReason",
            editable: true,
            disabled: true,
            width: "20%",
            inputType: {
                options: zeroVatReasonOptions,
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t("General.customVat"),
            field: "customVat",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'number',
            }
        },
    ]
    useEffect(() => {
        setTableColumns(supplierInstallationsColumns.slice());
    }, [locale])

    const [tableColumns, setTableColumns] = useState(supplierInstallationsColumns.slice());

    const parentMydataActions = {
        insert: (e, data) => {
            let tempInstallations = Object.assign({}, newInstallation);
            if (e.key !== "Enter") {
                tempInstallations[data.field] = data.value;
                dispatch(setNewInstallations(tempInstallations)); // Update redux
                let oldInstallations = newSupplier.installations;
                if (data.field === "no") {
                    const findDuplicate = oldInstallations.filter(installation => installation.no.toString() === data.value);
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                        dispatch(resetNewInstallations());
                        return;
                    }
                }
                let updatedInstallation = Object.assign({}, tempInstallations);
                if ((updatedInstallation && updatedInstallation.vatCategory === 'Zero VAT' && updatedInstallation.vatReason === '') || (updatedInstallation && updatedInstallation.vatCategory === 'Custom VAT' && updatedInstallation.no !== '' && updatedInstallation.customVat === '')) {
                    dispatch(setSaveEditSupplier(false));
                }
                if (updatedInstallation && (updatedInstallation.address !== '' && updatedInstallation.DOY !== '' && updatedInstallation.city !== '' && updatedInstallation.no !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.vatCategory !== '')) {
                    updatedInstallation.id = oldInstallations.length;
                    dispatch(setEditSupplier({
                        ...newSupplier,
                        installations: [...oldInstallations, updatedInstallation]
                    }));
                    dispatch(resetNewInstallations()); // Reset
                    dispatch(setSaveEditSupplier(true));
                    toast.success('Please press Save in order to save the installation changes');
                } else if (updatedInstallation && (newSupplier.categoryName === "Supplier within E.U." || newSupplier.categoryName === "Supplier outside E.U.") && (updatedInstallation.address !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.city !== '' && updatedInstallation.vatCategory !== '')) {
                    updatedInstallation.no = oldInstallations.length;
                    updatedInstallation.id = oldInstallations.length;
                    dispatch(setEditSupplier({
                        ...newSupplier,
                        installations: [...oldInstallations, updatedInstallation]
                    }));
                    dispatch(resetNewInstallations()); // Reset
                    dispatch(setSaveEditSupplier(true));
                    toast.success('Please press Save in order to save the installation changes');
                }
            } else {
                let updatedInstallation = Object.assign({}, newInstallation);
                let oldInstallations = newSupplier.installations;
                if (data.field === "no") {
                    const findDuplicate = oldInstallations.filter(installation => installation.no.toString() === data.value);
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                        dispatch(resetNewInstallations());
                        return;
                    }
                }
                if (data.field === 'add' || e.key === 'Enter') {
                    if (updatedInstallation && (updatedInstallation.address !== '' && updatedInstallation.DOY !== '' && updatedInstallation.city !== '' && updatedInstallation.vatCategory !== '' && updatedInstallation.no !== '')) {
                        updatedInstallation.id = oldInstallations.length;
                        dispatch(setEditSupplier({
                            ...newSupplier,
                            installations: [...oldInstallations, updatedInstallation]
                        }));
                        dispatch(resetNewInstallations()); // Reset
                        dispatch(setSaveEditSupplier(true));
                        toast.success('Please press Save in order to save the installation changes');
                    } else if (updatedInstallation && (newSupplier.categoryName === "Supplier within E.U." || newSupplier.categoryName === "Supplier outside E.U.") && (updatedInstallation.address !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.city !== '' && updatedInstallation.no !== '' && updatedInstallation.vatCategory !== '')) {
                        updatedInstallation.id = oldInstallations.length;
                        dispatch(setEditSupplier({
                            ...newSupplier,
                            installations: [...oldInstallations, updatedInstallation]
                        }));
                        dispatch(resetNewInstallations()); // Reset
                        dispatch(setSaveEditSupplier(true));
                        toast.success('Please press Save in order to save the installation changes');
                    }
                }
            }
        },
        update: (data, id) => {
            if (!saveNewSupplier) dispatch(setSaveNewSupplier(true));

            let installations = newSupplier.installations.slice();
            if (data?.no) {
                const findDuplicate = installations.filter(installation => installation.no.toString() === data.no);
                if (findDuplicate.length > 0) {
                    toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                    return;
                }
            }
            if (installations.find(item => item.id === id) !== undefined) {
                installations[id] = {...installations[id], ...data};
                dispatch(setNewSupplier({...newSupplier, installations: installations})); // update data
            }
        },
        selected: () => {},
        delete: (id) => {
            if (!saveNewSupplier) dispatch(setSaveNewSupplier(true));

            let installations = newSupplier.installations.slice();
            if (id !== '' && Number.isInteger(id)) {
                installations = deleteObjectFromArrayOfObjects(installations, id, 'no');
                dispatch(setNewSupplier({...newSupplier, installations: installations}))
            }
        }
    }

    return (
        <div className="new-supplier-general">
            <p className="text-muted"><i>{t("General.installations")}</i></p>
            <EditableTable
                tableName="Supplier New Installations"
                key={Math.random()}
                allowActions={true}
                allowToggleColumns={false}
                columns={tableColumns}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                data={newSupplier.installations}
                onUpdate={parentMydataActions}
            />
        </div>
    )
}

export default NewSupplierInstallations;
